import {useEffect, useState} from "react";
import "../../../css/profile.scss"
import {UserUtils} from "../../../utils/UserUtils.js";

export default function ProfileIcon({onClick})
{
    const user = UserUtils.getCurrentUser();
    const [encodedProfilePicture, setEncodedProfilePicture] = useState(null)

    useEffect(() =>
    {
        fetch("/api/profile-picture", { credentials: "include"})
            .then(res =>
            {
                if(res.ok) return res.text();
                else throw new Error(`Failed to get encoded profile picture: ${res.status} - ${res.statusText}`);
            })
            .then(str => setEncodedProfilePicture(str))
            .catch(err => console.error(err));
    }, []);

    return (
        <div className="profile-icon-area" onClick={onClick}>
            {
                encodedProfilePicture != null ? (
                    <img src={encodedProfilePicture} alt="profile-picture"/>
                ) :
                (
                    <div>
                        <span>{user.firstName.substring(0, 1)}{user.lastName.substring(0, 1)}</span>
                    </div>
                )
            }
        </div>
    );
}